<template>
  <div>
    <!-- <b-card
      class="mb-2 shadow"
      header="Activité du créancier"
      bg-variant="secondary"
      header-text-variant="light"
      header-tag="h6"
    > -->
    <b-row>
      <b-col lg="6">
        <div v-if="isActiveWarrants()">
          <div v-for="(hm, index) in warrants" :key="index">
            <div v-if="mandatsFiltered(hm.mandats).length > 0">
              <b-card-sub-title class="my-3">
                {{ typeMandat(hm.mandats) }} du {{ toDate(hm.date) }}
                <span v-if="hm.facture.ID"
                  >- Facture liée :
                  <b-link
                    :to="{
                      name: 'invoiceView',
                      params: { id: hm.facture.ID },
                    }"
                    >{{ hm.facture.ID }}</b-link
                  >
                </span>
              </b-card-sub-title>
              <b-table
                fixed
                id="warrantsTable"
                small
                striped
                hover
                :fields="warrantsFields"
                :items="mandatsFiltered(hm.mandats)"
              >
                <template v-slot:cell(date_ouverture)="data">{{
                  toDate(data.item.date_ouverture)
                }}</template>
                <template v-slot:cell(ID)="data">
                  <b-link
                    :to="{
                      name: 'warrantView',
                      params: { id: data.item.ID },
                    }"
                    >{{ data.item.ID }}</b-link
                  >
                </template>
                <template v-slot:cell(debiteur)="data">
                  <b-link
                    v-if="data.item.status !== 'unused'"
                    :to="{
                      name: 'debtorView',
                      params: { id: data.item.debiteurID },
                    }"
                    >{{ data.item.debiteur }}</b-link
                  >
                  <span v-if="data.item.status == 'unused'">
                    <b-button size="sm">Ouvrir</b-button>
                  </span>
                </template>
                <template v-slot:cell(status_i18n)="data">{{
                  data.item.status_i18n
                }}</template>
              </b-table>
            </div>
          </div>
        </div>
        <div v-else>
          <b-card-body>
            <b-alert show>Pas de mandats actifs pour ce créancier</b-alert>
          </b-card-body>
        </div>
      </b-col>
      <b-col lg="6" v-if="paymentsLoaded">
        <template v-if="payments.length > 0">
          <b-card-sub-title class="my-3"> Paiements </b-card-sub-title>
          <b-table
            v-if="payments.length > 0"
            id="paymentsTable"
            striped
            small
            hover
            :fields="paymentsFields"
            :items="payments"
          >
            <template v-slot:cell(date)="data">{{
              toDate(data.item.date)
            }}</template>
            <template v-slot:cell(mandatID)="data">
              <b-link
                :to="{
                  name: 'warrantView',
                  params: { id: data.item.mandatID },
                }"
                >{{ data.item.mandatID }}</b-link
              >
            </template>
            <template v-slot:cell(debiteur)="data">
              <b-link
                :to="{
                  name: 'debtorView',
                  params: { id: data.item.debiteurID },
                }"
                >{{ data.item.debiteur }}</b-link
              >
            </template>

            <template v-slot:bottom-row>
              <td />
              <td />
              <td class="text-center">
                <strong>Total</strong>
              </td>
              <td>
                <strong>
                  <span class="float-right"
                    >{{
                      paymentsTotalChezNous.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    }}
                    €</span
                  >
                </strong>
              </td>
              <td>
                <strong>
                  <span class="float-right"
                    >{{
                      paymentsTotalChezVous.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    }}
                    €</span
                  >
                </strong>
              </td>
            </template>
          </b-table>
          <div class="text-right mb-3 mr-1" style="font-size: 0.8em;">
            <strong>Total général :
            {{
              paymentsTotal.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            }}
            €</strong>
          </div>
        </template>
        <div v-else>
          <b-card-body>
            <b-alert show>Pas de paiements pour ce créancier</b-alert>
          </b-card-body>
        </div>
        <div v-if="paymentsTotal > 0" class="text-right">
          <b-button
            :to="{
              name: 'invoicesCommission',
              params: { id: $props.id },
            }"
            ><i class="fad fa-file-invoice mr-2"></i>Facture
            commission</b-button
          >
        </div>
      </b-col>
    </b-row>
    <!-- </b-card> -->
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import creditors from "@/services/creditors.js";
export default {
  name: "creditor-activity",
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    active: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loaded: false,
      paymentsLoaded: false,
      paymentsTotalChezNous: 0,
      paymentsTotalChezVous: 0,
      paymentsTotal: 0,
      payments: [],
      paymentsFields: [
        {
          key: "date",
          label: "Date",
          sortable: true,
        },

        {
          key: "mandatID",
          label: "Numéro de mandat",
          sortable: true,
        },
        {
          key: "debiteur",
          label: "Débiteur",
          sortable: true,
        },
        {
          key: "chez_nous",
          label: "Chez nous",
          class: "text-right",
          formatter: function(value, key, item) {
            if (item.reception == "societe") {
              return item.montant + " €";
            } else {
              return "";
            }
          },
        },
        {
          key: "chez_vous",
          label: "Chez vous",
          class: "text-right",
          formatter: function(value, key, item) {
            if (item.reception == "creancier") {
              return item.montant + " €";
            } else {
              return "";
            }
          },
        },
      ],
      warrants: [],
      warrantsFields: [
        {
          key: "date_ouverture",
          label: "Date",
          sortable: true,
        },
        {
          key: "ID",
          label: "Numéro de mandat",
          sortable: true,
        },
        {
          key: "status_i18n",
          label: "Statut",
          sortable: true,
        },
        {
          key: "debiteur",
          label: "Débiteur",
          sortable: true,
        },
      ],
    };
  },
  created() {
    creditors.warrants(this.$props.id).then((response) => {
      this.warrants = response.data.records;
      this.loaded = true;
    });
    creditors.payments(this.$props.id).then((response) => {
      this.payments = response.data;
      this.paymentsLoaded = true;
      this.paymentsTotalChezNous = this.payments
        .filter((el) => el.reception == "societe")
        .reduce((a, b) => a + parseFloat(b.montant), 0);
      this.paymentsTotalChezVous = this.payments
        .filter((el) => el.reception == "creancier")
        .reduce((a, b) => a + parseFloat(b.montant), 0);
      this.paymentsTotal =
        this.paymentsTotalChezNous + this.paymentsTotalChezVous;
    });
  },
  methods: {
    isActiveWarrants() {
      let val = false;
      this.warrants.forEach((hm) => {
        hm.mandats.forEach((mandat) => {
          if (mandat.status == "open") {
            val = true;
          }
        });
      });
      return val;
    },
    mandatsFiltered(hm) {
      if (this.active) {
        return hm.filter((x) => x.status == "open");
      }
      return hm;
    },
    typeMandat(hm) {
      if (hm.length > 1) {
        return "Carnet de " + hm.length + " mandats";
      }
      return "Mandat unique";
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped></style>
